import { render } from "./App.vue?vue&type=template&id=464530cc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=464530cc&lang=less"

import exportComponent from "../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__